module.exports = __webpack_public_path__ + "img/xianshimiaosha@2x.png?v=c27696fe";